export * from '@primeuix/themes/nora/textarea';
export { default } from '@primeuix/themes/nora/textarea';
